const TARGET_DATE = new Date('2026-05-21T17:00:00+02:00');

/**
 * Czech plural forms for time units.
 * Czech has 3 forms: singular (1), few (2-4), and plural (5+/0).
 */
function czechPlural(n, one, few, many) {
    if (n === 1) return one;
    if (n >= 2 && n <= 4) return few;
    return many;
}

/**
 * English plural forms for time units.
 */
function englishPlural(n, singular, plural) {
    return n === 1 ? singular : plural;
}

/**
 * Detect page language from html lang attribute.
 */
function getLanguage() {
    return document.documentElement.lang || 'cs';
}

function getTimeRemaining() {
    const now = new Date();
    const diff = TARGET_DATE - now;

    console.log(TARGET_DATE, now, diff);

    if (diff <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0, total: 0 };
    }

    const seconds = Math.floor((diff / 1000) % 60);
    const minutes = Math.floor((diff / 1000 / 60) % 60);
    const hours = Math.floor((diff / 1000 / 60 / 60) % 24);
    const days = Math.floor(diff / 1000 / 60 / 60 / 24);

    return { days, hours, minutes, seconds, total: diff };
}

/**
 * @param {number} value
 * @return {string}
 */
function formatNumber(value) {
    return value <= 9 ? `0${value}` : value;
}

function updateCountdown() {
    const timersRow = document.querySelector('.countdown__timers-row');
    if (!timersRow) {
        console.error("Could not find timers row");
        return;
    }

    const timers = timersRow.querySelectorAll('.countdown__timer');
    if (timers.length < 4) {
        console.error("Could not find timers");
        return;
    }

    const { days, hours, minutes, seconds } = getTimeRemaining();
    const lang = getLanguage();

    timers[0].style.display = days === 0 ? 'none' : '';
    timers[0].querySelector('.countdown__timer__value').textContent = formatNumber(days);
    timers[1].querySelector('.countdown__timer__value').textContent = formatNumber(hours);
    timers[2].querySelector('.countdown__timer__value').textContent = formatNumber(minutes);
    timers[3].querySelector('.countdown__timer__value').textContent = formatNumber(seconds);

    if (lang === 'en') {
        timers[0].querySelector('.countdown__timer__label').textContent =
            englishPlural(days, 'day', 'days');
        timers[1].querySelector('.countdown__timer__label').textContent =
            englishPlural(hours, 'hour', 'hours');
        timers[2].querySelector('.countdown__timer__label').textContent =
            englishPlural(minutes, 'minute', 'minutes');
        timers[3].querySelector('.countdown__timer__label').textContent =
            englishPlural(seconds, 'second', 'seconds');
    } else {
        timers[0].querySelector('.countdown__timer__label').textContent =
            czechPlural(days, 'den', 'dny', 'dnů');
        timers[1].querySelector('.countdown__timer__label').textContent =
            czechPlural(hours, 'hodina', 'hodiny', 'hodin');
        timers[2].querySelector('.countdown__timer__label').textContent =
            czechPlural(minutes, 'minuta', 'minuty', 'minut');
        timers[3].querySelector('.countdown__timer__label').textContent =
            czechPlural(seconds, 'vteřina', 'vteřiny', 'vteřin');
    }
}

export function initCountdown() {
    updateCountdown();
    setInterval(updateCountdown, 500);
}
